export const SHOW_MORE_STATE_VALUES = {
  SHOW_MORE_MY_REPORTS: 'SHOW_MORE_MY_REPORTS',
  SHOW_MORE_TEMPLATES: 'SHOW_MORE_TEMPLATES',
  SHOW_LESS: 'SHOW_LESS'
};
export const EMPTY_SEARCH_VALUE = '';
export const SEARCH_REFERRER_STORAGE_KEY = 'reports-list-search-referrer';
export const AI_EXPLANATION_KEYS = {
  FIRST_EXPLANATION: 'firstExplanation',
  SECOND_EXPLANATION: 'secondExplanation',
  THIRD_EXPLANATION: 'thirdExplanation',
  FOURTH_EXPLANATION: 'fourthExplanation'
};
export const AI_MATCHING_REPORT_TEMPLATE_KEYS = {
  FIRST_MATCH: 'firstBestReportTemplate',
  SECOND_MATCH: 'secondBestReportTemplate',
  THIRD_MATCH: 'thirdBestReportTemplate',
  FOURTH_MATCH: 'fourthBestReportTemplate'
};